export const QA_NAME_EPOST_FORM_ACTIONS_CALCULATE_BUTTON = 'calculate'
